class Storage {
    constructor() {
        this.mem = {};
    }

    set(key, value) {
        if (typeof (sessionStorage) != 'undefined') {
            sessionStorage.setItem(key, value);
        } else {
            this.mem[key] = value;
        }
        
        return value;
    }

    get(key) {
        if (typeof (sessionStorage) != 'undefined') {
            return sessionStorage.getItem(key);
        } else {
            return this.mem[key];
        }
    }

    remove(key) {
        if (typeof (sessionStorage) != 'undefined') {
            sessionStorage.removeItem(key);
        } else {
            delete this.mem[key];
        }
    }
}

export let storage = new Storage();


// WEBPACK FOOTER //
// ./scripts/booking/helpers/storage.js